import { ZodDate as IZodDate, z } from 'zod';

export type Month = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export function isMonth(value: number): value is Month {
  return value >= 1 && value <= 12;
}

/**
 * allow any dateish value (ISO string / unix timestamp)
 */
export const ZodDate = z.preprocess((input) => {
  if (typeof input === 'string' || typeof input === 'number') {
    const result = new Date(input);
    if (!isNaN(result.getTime())) {
      return result;
    }
  }
  return input;
}, z.date()) as z.ZodPipe<z.ZodTransform<Date, string | number | Date>, IZodDate>;
